var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { r as registerInstance, c as createEvent, h, g as getElement } from './core-6f498fd9.js';
var CsmTabs = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        /**
         * @deprecated
         * Define tab header alignement
         */
        this.alignement = 'left';
        this.tabsChilds = [];
        this.propChangeTrigger = false;
        this.csmTabChange = createEvent(this, "csmTabChange", 7);
        this.mounted = createEvent(this, "mounted", 7);
    }
    class_1.prototype.validateAlign = function (newValue, _) {
        var isBlank = typeof newValue == null;
        var invalid = typeof newValue === 'string' && newValue != 'left' && newValue != 'center' && newValue != 'right';
        if (isBlank) {
            throw new Error('align: value required');
        }
        if (invalid) {
            throw new Error('align: invalid entry');
        }
    };
    class_1.prototype.updateTab = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.propChangeTrigger = !this.propChangeTrigger;
                return [2 /*return*/];
            });
        });
    };
    class_1.prototype.componentWillLoad = function () {
        var isSelectedTab = false;
        this.tabsChilds = Array.from(this.element.querySelectorAll('csm-tab')).map(function (el) {
            if (el.selected && isSelectedTab === false) {
                isSelectedTab = true;
                return el;
            }
            if (el.selected && isSelectedTab === true) {
                el.selected = false;
                return el;
            }
            return el;
        });
    };
    class_1.prototype.componentDidLoad = function () {
        this.mounted.emit();
    };
    class_1.prototype.selectTab = function (tab, index) {
        var _this = this;
        this.tabsChilds = this.tabsChilds.map(function (el, i) {
            if (index !== i) {
                el.selected = false;
            }
            else {
                el.selected = true;
                _this.csmTabChange.emit({
                    label: tab.label,
                    index: index,
                });
                var event = new CustomEvent('csmTabSelect', { detail: tab });
                tab.dispatchEvent(event);
            }
            return el;
        });
    };
    class_1.prototype.generateTabsHeader = function () {
        var _this = this;
        return (h("div", { class: 'csm-tab__header csm-tab__header--align-' + this.alignement, part: "csm-tabs-header" }, this.tabsChilds.map(function (tab, i) {
            var customProps = _this.getCustomProps(tab, ['padding-', 'full-width', 'no-uppercase']);
            var dataAttributes = _this.getDataAttrs(tab);
            return (h("csm-tabs-header-cell", Object.assign({}, dataAttributes, customProps, { part: "csm-tabs-header-cell " + tab.label, label: tab.label, icon: tab.icon, id: tab.headerId, selected: tab.selected, disabled: tab.disabled, onClick: !tab.disabled && (function (_) { return _this.selectTab(tab, i); }) })));
        })));
    };
    class_1.prototype.getDataAttrs = function (tab) {
        var dataAttrs = Array.from(tab.attributes).filter(function (a) { return a.name.startsWith('data-'); });
        return dataAttrs.reduce(function (acc, cur) {
            acc[cur.name] = cur.value;
            return acc;
        }, {});
    };
    class_1.prototype.getCustomProps = function (tab, props) {
        var customProps = tab
            .getAttributeNames()
            .filter(function (e) { return props.findIndex(function (p) { return e.startsWith(p); }) > -1; })
            .reduce(function (acc, cur) {
            acc[cur] = true;
            return acc;
        }, {});
        return customProps;
    };
    class_1.prototype.render = function () {
        return (h("div", { class: "csm-tab", part: "csm-tab" }, this.generateTabsHeader(), h("div", { class: "csm-tab__content", part: "csm-tab-content" }, h("slot", null))));
    };
    Object.defineProperty(class_1.prototype, "element", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "watchers", {
        get: function () {
            return {
                "alignement": ["validateAlign"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "style", {
        get: function () { return "\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:400;src:url(../assets/fonts/ProximaNova-Regular.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Regular.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:600;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:700;src:url(../assets/fonts/ProximaNova-Semibold.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Semibold.woff) format(\"woff\")}\@font-face{font-family:Proxima Nova;font-style:normal;font-weight:900;src:url(../assets/fonts/ProximaNova-Black.woff2) format(\"woff2\"),url(../assets/fonts/ProximaNova-Black.woff) format(\"woff\")}\@font-face{font-family:CS-FontIcon-v19;src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb);src:url(../assets/icons/CS-FontIcon-v19.eot?cz1hbb#iefix) format(\"embedded-opentype\"),url(../assets/icons/CS-FontIcon-v19.ttf?cz1hbb) format(\"truetype\"),url(../assets/icons/CS-FontIcon-v19.woff?cz1hbb) format(\"woff\"),url(../assets/icons/CS-FontIcon-v19.svg?cz1hbb#CS-FontIcon-v18) format(\"svg\");font-weight:400;font-style:normal;font-display:block}:root{font-family:Proxima Nova,sans-serif}*,:after,:before{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:inherit}.csm-tab{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%}.csm-tab .csm-tab__header{border-bottom:1px solid #e3e6ec;padding:0;display:-ms-flexbox;display:flex}.csm-tab .csm-tab__header--align-left{-ms-flex-pack:start;justify-content:flex-start}.csm-tab .csm-tab__header--align-center{-ms-flex-pack:center;justify-content:center}.csm-tab .csm-tab__header--align-right{-ms-flex-pack:end;justify-content:flex-end}.csm-tab .csm-tab__content{overflow:auto;height:100%}:host(.align-left) .csm-tab .csm-tab__header{-ms-flex-pack:start;justify-content:flex-start}:host(.align-center) .csm-tab .csm-tab__header{-ms-flex-pack:center;justify-content:center}:host(.align-right) .csm-tab .csm-tab__header{-ms-flex-pack:end;justify-content:flex-end}:host(.align-space-around) .csm-tab .csm-tab__header{-ms-flex-pack:distribute;justify-content:space-around}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
export { CsmTabs as csm_tabs };
